import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bool, func, number, shape } from "prop-types";
import { actions as depositsActions, selectors as depositsSelectors } from "reducers/deposits";
import * as i18n from "util/i18n";

import useReactPrint from "pages/_components/Print/useReactToPrint";
import Notification from "pages/_components/Notification";
import PageLoading from "pages/_components/PageLoading";
import Container from "pages/_components/Container";
import gaEventTracker, { events } from "util/gaEventTracker";
// import { isDesktop } from "react-device-detect";
import { resizableRoute } from "pages/_components/Resizable";
import { isIOS } from "react-device-detect";
import Image from "pages/_components/Image";
import HistoricalDepositDetailList from "./_components/HistoricalDepositDetailList";
import DepositsHead from "./_components/DepositsHead";

const HistoricalDetails = (props) => {
    const { dispatch, match, selectedDeposit, fetching, depositsLength, isDesktop } = props;

    const isLoading = fetching || !selectedDeposit?.depositNumber;

    useEffect(() => {
        dispatch(depositsActions.readHistoricDeposit(match.params.id));
        dispatch(depositsActions.setDepositsScreenToHistorical(true));
    }, [depositsLength, match.params.id]);

    useEffect(
        () => () => {
            dispatch(depositsActions.cleanSelectedDeposit());
        },
        [],
    );

    const title = selectedDeposit?.productAlias
        ? selectedDeposit.productAlias
        : `${i18n.get("productType.PF")} ${selectedDeposit?.shortLabel}`;

    // const { componentRef, handlePrint } = useReactPrint(title, null, "/deposits/historical/");

    const { componentRef, handlePrint } = useReactPrint(title, null);

    const handleDownloadClick = () => {
        gaEventTracker.triggerEvent(events.pf_historicos_descarga());
        // dispatch(depositsActions.downloadDeposit(selectedDeposit, "pdf", false));
        handlePrint();
    };

    return (
        <PageLoading loading={isLoading}>
            {selectedDeposit && (
                <div className="transaction-ticket" ref={componentRef}>
                    <Notification scopeToShow="deposit/details" />
                    <div className="hidden show-print">
                        <div className="voucher-header">
                            <Image src="images/logoCompany.svg" />
                            <div
                                className="bibank-data"
                                dangerouslySetInnerHTML={{ __html: i18n.get("report.bibank.header") }}
                            />
                        </div>
                    </div>
                    <div
                        className={
                            isIOS
                                ? "media-object media-object-ios column hidden show-print"
                                : "media-object column hidden show-print"
                        }>
                        {title && (
                            <div className="text-center">
                                <h1 className="hidden show-print">{title}</h1>
                            </div>
                        )}
                    </div>
                    <DepositsHead
                        titleText={isDesktop ? title : "Detalle de Histórico"}
                        backLinkTo="/deposits"
                        exportList="true"
                        className="deposit-head hide-print"
                        depositNumber={selectedDeposit.depositNumber}
                        handleClick={() => handleDownloadClick()}
                    />
                    <Container className="container--layout">
                        <HistoricalDepositDetailList deposit={selectedDeposit} {...props} />
                    </Container>
                </div>
            )}
        </PageLoading>
    );
};

HistoricalDetails.propTypes = {
    selectedDeposit: shape({}).isRequired,
    depositsLength: number.isRequired,
    fetching: bool.isRequired,
    match: shape().isRequired,
    dispatch: func.isRequired,
    isDesktop: bool.isRequired,
};

const mapStateToProps = (state) => ({
    selectedDeposit: depositsSelectors.getSelectedDeposit(state),
    fetching: depositsSelectors.getHistoricalDepositsFetching(state),
    depositsLength: depositsSelectors.getDepositsLength(state),
});

export default connect(mapStateToProps)(resizableRoute(HistoricalDetails));
